module.exports = __webpack_public_path__ + "static/media/Coco Deng.5d2e3b6c.png";